import { useEffect, useRef, useState } from 'react';

export function useRefState(initialValue) {
    const [state, setState] = useState(initialValue);
    const stateRef = useRef(state);

    useEffect(
        () => { stateRef.current = state; },
        [state],
    );

    return [state, setState, stateRef];
}

const memoryState = {};

export function useMemoryState(key, initialState) {
    const [state, setState] = useState(() => {
        const hasMemoryValue = Object.prototype.hasOwnProperty.call(memoryState, key);
        if (hasMemoryValue) {
            return memoryState[key];
        }
          
        return typeof initialState === 'function' ? initialState() : initialState;
    });

    function onChange(nextState) {
        memoryState[key] = nextState;
        setState(nextState);
    }

    return [state, onChange];
}



// WEBPACK FOOTER //
// ./app/helpers/react.utils.js